import * as React from "react";
import { ResponsiveLine, Serie } from "@nivo/line";
import { createRange, roundToBottom, roundToTop } from "../../misc/math-functions";

interface PressureTimeGraphProps {
    data: Serie[];
    minTime: number;
    maxTime: number;
    minPressure: number;
    maxPressure: number;
}

function scaleGraph(minTime, maxTime, minPressure, maxPressure) {
    const minP = roundToBottom(minPressure);
    const maxP = roundToTop(maxPressure);

    const minT = roundToBottom(minTime);
    const maxT = roundToTop(maxTime);

    const xTicks = createRange(minT, maxT, 1);
    xTicks.push(maxT);

    const yTicks = createRange(minP, maxP, 10);
    yTicks.push(maxP);

    return {
        minT,
        maxT,
        minP,
        maxP,
        xTicks,
        yTicks
    }
}

export const PressureTimeGraph = ({ data, minTime, maxTime, minPressure, maxPressure }: PressureTimeGraphProps) => {
    const {
        minT,
        maxT,
        minP,
        maxP,
        xTicks,
        yTicks
    } = scaleGraph(minTime, maxTime, minPressure, maxPressure);

    return (<ResponsiveLine
        data={data}
        curve="basis"
        margin={{ top: 30, right: 160, bottom: 50, left: 60 }}
        xScale={{ type: 'linear', min: minT, max: maxT }}
        yScale={{ type: 'linear', min: minP, max: maxP }}
        colors={d => d.color}
        animate={false}
        axisTop={null}
        axisRight={null}
        axisBottom={{
            tickValues: xTicks,
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            legend: 'Time (seconds)',
            legendOffset: 30,
            legendPosition: 'middle'
        }}
        axisLeft={{
            tickValues: yTicks,
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            legend: 'Pressure (cm/H2O)',
            legendOffset: -40,
            legendPosition: 'middle'
        }}
        lineWidth={1}
        enablePoints={false}
        enablePointLabel={false}
        useMesh={true}
        enableCrosshair={true}
        tooltip={({ point }) => {
            return <div className="lineChartTooltip">
                <span className="lineChartTooltipIcon" style={{ background: point.color }}></span>
                <span>Time: <strong>{point.data.x}</strong> Pressure: <strong>{point.data.y}</strong></span>
            </div>
        }}
        isInteractive={true}
        gridXValues={xTicks}
        gridYValues={yTicks}
        legends={[
            {
                anchor: 'top',
                direction: 'row',
                justify: false,
                translateX: 10,
                translateY: -20,
                itemsSpacing: 2,
                itemDirection: 'left-to-right',
                itemWidth: 80,
                itemHeight: 12,
                itemOpacity: 0.75,
                symbolSize: 12,
                symbolShape: 'square',
                symbolBorderColor: 'rgba(0, 0, 0, .5)',
            }
        ]}
        markers={[
            {
                value: 0,
                axis: 'y',
                lineStyle: {
                    stroke: 'black'
                }
            },
            {
                value: 0,
                axis: 'x',
                lineStyle: {
                    stroke: 'black'
                }
            }
        ]}
    />);
}